import questionTag from "@/components/question-tag/question-tag.vue";

export default {
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: String,
    disabled: Boolean,
    checked: Boolean,
    incorrect: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hint: String,
    theme: {
      type: String,
      default: "",
    },
  },
  components: {
    questionTag,
  },
  computed: {
    classModifiers() {
      return {
        checkbox: true,
        [`checkbox--${this.theme}`]: this.theme,
        "checkbox--checked": this.checked,
        "checkbox--is-incorrect": this.incorrect,
      };
    },
    labelClassModifiers() {
      return {
        checkbox__label: true,
        "checkbox__disabled-color": this.disabled,
      };
    },
  },
  methods: {
    onChange(e) {
      this.$emit("change", e.target.checked);
    },
  },
};
